// extracted by mini-css-extract-plugin
export default {"screenXLMin":"1279px","step-label":"styles_step-label__E50wK","bottom-margin":"styles_bottom-margin__3ElV8"};